module.exports = __webpack_public_path__ + "static/media/m21.f319cdf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/merletto/m21.jpg
// module id = 442
// module chunks = 0